export const DEV_TOOLBOX_MOCK_ITEM_ID = "dev-toolbox-mock";

export type DevBuyerFlowParam =
  | "checkout-start"
  | "partner-override"
  | "checkout-modal"
  | "chat-warning";

export function resolveDevBuyerFlowFromScenario(
  scenarioId: string | null,
): DevBuyerFlowParam | null {
  switch (scenarioId) {
    case "buyer-flow.checkout-start":
      return "checkout-start";
    case "buyer-flow.checkout-partner-override":
      return "partner-override";
    case "buyer-flow.checkout-modal":
      return "checkout-modal";
    case "buyer-flow.chat-warning":
      return "chat-warning";
    default:
      return null;
  }
}

export function shouldOpenPaymentModalForDevFlow(
  flow: DevBuyerFlowParam | null,
): boolean {
  // chat-warning scenario now opens the pay-first modal (warning UI removed Phase 3)
  return flow === "checkout-modal" || flow === "chat-warning";
}

/** @deprecated Phase 3 — chat warning modal removed; always false. */
export function shouldOpenChatWarningForDevFlow(
  _flow: DevBuyerFlowParam | null,
): boolean {
  return false;
}
